var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.893 22.5873V24.8095M19.893 27.7143V33.746M25.7244 27.6667L26.9665 39.8608C27.0324 40.5081 27.5695 41 28.2102 41H36.5829C37.2236 41 37.7607 40.5081 37.8266 39.8608L39.0687 27.6667M25.7244 27.6667L25.3496 23.9878C25.2733 23.2388 25.8519 22.5873 26.5934 22.5873H38.1997C38.9412 22.5873 39.5197 23.2388 39.4434 23.9878L39.0687 27.6667M25.7244 27.6667H39.0687M7.38939 4.1746H17.3922C18.2554 4.1746 18.9552 3.46394 18.9552 2.5873C18.9552 1.71066 18.2554 1 17.3922 1H7.38939C6.5262 1 5.82645 1.71066 5.82645 2.5873C5.82645 3.46394 6.5262 4.1746 7.38939 4.1746ZM8.32716 4.1746H16.1419V6.71429C16.1419 6.71429 18.9552 9.25397 20.2056 10.8413C20.8948 11.7163 21.6791 13.0737 22.2442 15.2857C22.7041 17.0863 23.0189 19.4533 23.0189 22.5873V36.873C22.9147 38.2487 21.9561 41 18.9552 41H5.51386C2.513 41 1.55439 38.2487 1.4502 36.873V22.5873C1.4502 18.1974 2.06769 15.3126 2.83691 13.381C3.29149 12.2395 3.79906 11.4309 4.2635 10.8413C5.51386 9.25397 8.32716 6.71429 8.32716 6.71429V4.1746Z",
    stroke: "#03422F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.0661C4.72589 13.8545 6.30212 14.0661 12.2413 15.9709C18.1805 17.8756 20.3732 16.8174 22.4072 15.9709",
    stroke: "#03422F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilk);
export default __webpack_public_path__ + "static/media/milk.41b45043ee8fd02a4057e3650a8c747b.svg";
export { ForwardRef as ReactComponent };